import React, { useEffect, useState } from "react";
import axios from "axios";
import DevolutionItem from "./devolutionitem";
import IconNull from "../componentsStyled/icon/iconNull";
import Slider from "react-slick";
import ModalTimeout from "./modaltimeout";
import apiConnect from "../api/apiConnect";
import { Box, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Skeleton, TextField } from "@mui/material";
import LoadingBox from "./LoadingBox";
type Devolution = {
  id: string;
  imgs: { url: string }[];
  created_at: string;
  status: {
    color: string;
    status: string;
    title: string;
  };
};
type auth = {
  basicAuth: string;
  code: number;
  email: string;
  customerId: string;
  token: string;
};

const ListagemDevolucoes: React.FC = () => {
  const [devolucoes, setDevolucoes] = useState<Devolution[]>([]);
  const [searchTerm, setSearchTerm] = useState<any>("");
  const [searchResult, setSearchResult] = useState<Devolution[]>([]);
  const [modalIsOpen, setOpenmodal] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleGetDevolutions = async () => {
    let auth = localStorage.getItem("auth");
    if (!auth) {
      setOpenmodal(true);
      return;
    }
    const authObj: auth = JSON.parse(auth);
    setLoading(true);
    apiConnect.apiAPP
      .get("/accompany/" + authObj.customerId, {
        headers: {
          Authorization: "Basic " + authObj.basicAuth,
        },
        timeout: 10000,
      })
      .then((response) => {
        const fetchedDevolucoes = response.data;
        // console.log(fetchedDevolucoes);

        setDevolucoes(fetchedDevolucoes);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("auth");
          openModal();
        } else {
          // Handle other errors if needed
          console.log(error);
        }
      });
  };

  useEffect(() => {
    handleGetDevolutions();
  }, []);

  const handleSearch = () => {
    const filteredDevolucoes = devolucoes.filter((devolucao) => {
      if (String(devolucao.id).indexOf(searchTerm) > -1) {
        return devolucao;
      }
    });

    setSearchResult(filteredDevolucoes);
  };

  const openModal = () => {
    setOpenmodal(true);
  };
  const closeModal = () => {
    setOpenmodal(false);
  };

  if (loading) {
    return (
      <Box display={"flex"} flexDirection={"column"} gap={2}>
        <Skeleton variant="rounded" width={300} height={100} />
        <Skeleton variant="rounded" width={"100%"} height={300} />
      </Box>
    );
  } else {
    return (
      <Box display={"flex"} flexDirection={"column"} paddingX={{ xs: 1, md: 0 }}>
        <Box ml={{ xs: 2, md: 0 }}>
          <p style={{ fontSize: 25 }}>Minhas Solicitações</p>
        </Box>

        <Box display={"flex"} flexDirection={"column"} paddingX={{ xs: 0, md: 4 }} paddingY={{ xs: 0, md: 2 }}>
          <Box marginY={1}>
            <p style={{ fontWeight: 300 }}>Busca</p>
          </Box>
          <FormControl variant="outlined">
            <OutlinedInput
              placeholder="Procure por uma solicitação"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              onKeyDown={handleSearch}
              sx={{ bgcolor: "#F3F3F3", borderRadius: 5, width: { xs: "100%", md: "50%" } }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setSearchTerm("");
                      setSearchResult([]);
                    }}
                    edge="end">
                    {searchTerm.length > 0 ? (
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="m7.829 9.582-5.6 5.6a1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313 1.1 1.1 0 0 1-.315-.8q0-.487.315-.8l5.6-5.6-5.6-5.6a1.1 1.1 0 0 1-.315-.8q0-.487.315-.8a1.1 1.1 0 0 1 .8-.316q.485 0 .8.315l5.6 5.6 5.6-5.6a1.1 1.1 0 0 1 .8-.315q.485 0 .8.315a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8l-5.6 5.6 5.6 5.6a1.1 1.1 0 0 1 .315.8 1.1 1.1 0 0 1-.315.8 1.1 1.1 0 0 1-.8.315 1.1 1.1 0 0 1-.8-.313z"
                          fill="#1C1B1F"
                        />
                      </svg>
                    ) : (
                      <svg width="32" height="32" viewBox="-0.08 0 0.76 0.76" xmlns="http://www.w3.org/2000/svg">
                        <path d="M.566.62a.04.04 0 0 1-.062 0L.368.484A.224.224 0 1 1 .43.422l.136.136a.04.04 0 0 1 0 .062M.312.464a.18.18 0 1 0-.068.014.2.2 0 0 0 .068-.014" />
                      </svg>
                    )}
                  </IconButton>
                </InputAdornment>
              }
            />
          </FormControl>

          <Box marginY={5}>
            <p style={{ color: "#444", fontSize: 16, fontWeight: 300 }}>Selecione uma solicitação para ver seus detalhes</p>
          </Box>
          {loading ? (
            <LoadingBox loadType="static" />
          ) : (
            <Box>
              {devolucoes.length === 0 ? (
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                  <IconNull width={50} />
                  <p>Nenhuma devolução encontrada</p>
                  <p>no período selecionado.</p>
                </div>
              ) : (
                <Box display={"flex"} flexDirection={"row"} flexWrap={"wrap"} gap={3} alignItems={{ xs: "center", md: "initial" }}>
                  {searchResult.length > 0
                    ? searchResult.map((devolucao) => <DevolutionItem key={devolucao.id} devolucao={devolucao} />)
                    : devolucoes.map((devolucao) => <DevolutionItem key={devolucao.id} devolucao={devolucao} />)}
                </Box>
              )}
            </Box>
          )}
        </Box>

        <ModalTimeout isOpen={modalIsOpen} onRequestClose={closeModal} />
      </Box>
    );
  }
};

export default ListagemDevolucoes;
